'use client';

import EneasSVG from '@/assets/svg/EneasSVG';
import BackButton from '@/components/common/BackButton';
import { ErrorAlertLocalized } from '@/components/common/ErrorAlert';
import GlobalErrorSignout from '@/components/common/GlobalErrorSignout';
import { getFaro } from '@/monitoring/client/faro';
import { useEffect } from 'react';

const GlobalLocaleError = ({ error }: { error: Error }) => {
  useEffect(() => {
    getFaro()?.api.pushError(error);
  }, [error]);

  return (
    <main className="relative flex h-svh w-svw items-center justify-center bg-[#ECF3F1]">
      <BackButton />
      <GlobalErrorSignout />
      <div className="flex flex-col items-center gap-y-8">
        <EneasSVG
          aria-description={'Eneas logo'}
          height={31}
          width={200}
          className="fill-veni-green-900"
          fill="black"
        />
        <ErrorAlertLocalized variant="error" />
      </div>
    </main>
  );
};

export default GlobalLocaleError;
